module.exports = __webpack_public_path__ + "img/insta-15.d8f63c2b.jpg";